import type { IChatLogger } from "@1js/scc-types-logger";
import type { LoggerContextProps } from "../context/LoggerContext";

export const getLogger = (
  loggerContext?: LoggerContextProps
): IChatLogger | undefined => loggerContext?.logger;
